import { useState } from 'react';
import type { TableRowSelection } from 'antd/es/table/interface';
import { Table } from "antd";

export function useRowSelection() {
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const rowSelection: TableRowSelection<any> = {
        selectedRowKeys,
        onChange: (newKeys) => setSelectedRowKeys(newKeys),
        selections: [
            Table.SELECTION_ALL,
            Table.SELECTION_INVERT,
            Table.SELECTION_NONE,
            {
                key: 'odd',
                text: 'Seleccionar filas impares',
                onSelect: (changeableRowKeys) => {
                    const oddKeys = changeableRowKeys.filter((_, i) => i % 2 === 0);
                    setSelectedRowKeys(oddKeys);
                },
            },
            {
                key: 'even',
                text: 'Seleccionar filas pares',
                onSelect: (changeableRowKeys) => {
                    const evenKeys = changeableRowKeys.filter((_, i) => i % 2 !== 0);
                    setSelectedRowKeys(evenKeys);
                },
            },
        ],
    };

    return { selectedRowKeys, setSelectedRowKeys, rowSelection };
}
